import type { Plugin } from "@amplitude/analytics-core"

import { ROUTES_CONFIG } from "./routes.config"

export const REDACTED_VALUE = "[REDACTED]"

// Plugin to filter sensitive data
export const sensitiveDataPlugin: Plugin = {
    name: "sensitive-data-filter",
    type: "enrichment",
    setup: () => Promise.resolve(),
    execute: async event => {
        const excludedEventUrls = [ROUTES_CONFIG.loginUrl]

        // Exclude events for login page
        const currentUrl = window.location.pathname

        if (excludedEventUrls.includes(currentUrl)) {
            return null
        }

        // Apply redacting to element which is ignored by mouseflow
        if (event.event_type === "[Amplitude] Element Clicked") {
            const elementHierarchy = event.event_properties?.[
                "[Amplitude] Element Hierarchy"
            ] as { classes: string[] }[]

            if (
                elementHierarchy?.some(element =>
                    element.classes?.includes("mouseflow-ignore"),
                )
            ) {
                // Redact event properties
                event.event_properties = {
                    ...event.event_properties,
                    "[Amplitude] Element Text": REDACTED_VALUE,
                }
            }
        }

        return event
    },
}
